import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Icon from 'ol/style/Icon';


export function getSlowupMinResolutionForFeature(feature) {
  const categorySlowup = feature.get('category_slowup');
  if (categorySlowup) {
    if (categorySlowup === 'fairground' || categorySlowup === 'direction_arrow') {
      return 50;
    }
    return 10;
  }
  return null;
}


export function createSlowupStyle(cacheBusterService) {
  const outlineLineColor = [255, 51, 0];
  const innerLineColor = [255, 102, 0];

  const slowupLineStyles = {
    pro_skate: [
      new Style({
        stroke: new Stroke({
          color: outlineLineColor,
          width: 10,
          lineDash: [0, 13]
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: innerLineColor,
          width: 8,
          lineDash: [0, 13]
        }),
      }),
    ],
    nature: [
      new Style({
        stroke: new Stroke({
          color: outlineLineColor,
          width: 9,
          lineCap: 'butt',
          lineDash: [20, 15]
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: innerLineColor,
          width: 7,
          lineCap: 'butt',
          lineDash: [20, 15]
        }),
      }),
    ],
  };

  function createPlainLineStyle(outerWidth, innerWidth) {
    return [
      new Style({
        stroke: new Stroke({
          color: outlineLineColor,
          width: outerWidth,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: innerLineColor,
          width: innerWidth,
        }),
      }),
    ];
  }

  const smallResolutionLineStyle = createPlainLineStyle(8, 6);
  const bigResolutionLineStyle = createPlainLineStyle(6, 4);

  /**
   * @param {string} name
   * @param {number} resolution
   * @return {Style[]}
   */
  function getLineStyle(name, resolution) {
    if (resolution > 20) {
      return bigResolutionLineStyle;
    }
    const styles = slowupLineStyles[name];
    if (styles) {
      return styles;
    }
    return smallResolutionLineStyle;
  }

  const poiStylesCache = {};
  /**
   * @param {string} name
   * @return {Style}
   */
  function getPOIStyle(name) {
    let style = poiStylesCache[name];
    if (!style) {
      style = poiStylesCache[name] = new Style({
        image: new Icon({
          rotateWithView: true,
          crossOrigin: 'anonymous',
          size: [22, 22],
          src: cacheBusterService.addSuffix(`img/slowup/${name}.svg`)
        })
      });
    }
    return style;
  }

  /**
   * @param {import('ol/Feature.js').default} feature
   * @param {number} resolution
   */
  return (feature, resolution) => {
    const categorySurface = feature.get('category_surface');
    // line
    if (categorySurface) {
      return getLineStyle(categorySurface, resolution);
    }

    if (resolution < 50) {
      const categorySlowup = feature.get('category_slowup');
      if (categorySlowup) {
        if (resolution > 10 && categorySlowup !== 'fairground' && categorySlowup !== 'direction_arrow') {
          // faireground and direction arrows are displayed when resolution < 50
          // the others when resolution < 10
          return null;
        }
        const azimut = feature.get('azimut');
        const style = getPOIStyle(categorySlowup);
        const rotation = ((360 - (azimut || 0)) % 360) * Math.PI / 180;
        style.getImage().setRotation(rotation);
        const rotateWithView = azimut !== undefined;
        style.getImage().setRotateWithView(rotateWithView);
        return style;
      }
    }
  };
}
